import { RouteRecordRaw } from 'vue-router';
import {
  RegistryManagementPage,
  ModelsPage,
  RecordListPage,
  RegistrySettingsPage,
} from '@/pages/registry-management';

export const routeName = 'GestaoRegistros';

const recordManagementPermissions = [{ action: 'manage', subject: 'RecordManagement' }];

export const route: RouteRecordRaw = {
  path: 'gestao-registros',
  name: routeName,
  component: RegistryManagementPage,
  redirect: { name: 'GestaoRegistrosListaRegistros' },
  meta: {
    requiresAuth: true,
    breadcrumb: 'Gestão de Registros',
    permissions: recordManagementPermissions,
  },
  children: [
    {
      path: 'lista-registros',
      name: 'GestaoRegistrosListaRegistros',
      component: RecordListPage,
      meta: {
        requiresAuth: true,
        breadcrumb: 'Lista de Registros',
        permissions: recordManagementPermissions,
      },
    },
    {
      path: 'modelos',
      name: 'GestaoRegistrosModelos',
      component: ModelsPage,
      meta: {
        requiresAuth: true,
        breadcrumb: 'Modelos',
        permissions: recordManagementPermissions,
      },
    },
    {
      path: 'ajustar-configuracoes',
      name: 'GestaoRegistrosAjustarConfiguracoes',
      component: RegistrySettingsPage,
      meta: {
        requiresAuth: true,
        breadcrumb: 'Configurações',
        permissions: recordManagementPermissions,
      },
    },
  ],
};
